import { ReportsComponent } from './reports.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsRoutingModule } from './reports-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';


@NgModule({
  declarations: [ReportsComponent],
  imports: [
    CommonModule,
    NgbModule,
    ModalModule.forRoot(),
    ReportsRoutingModule
  ]
})
export class ReportsModule { }
